import NS from './reducer-name.js';

export const selectHasTimeLimits = state => !!state[NS]?.time;
export const selectHasDepositLimits = state => !!state[NS]?.deposit;
export const selectHasWagerLimits = state => !!state[NS]?.wager;
export const selectHasSpendingLimits = state => !!state[NS]?.spend;
export const selectHasLossLimits = state => !!state[NS]?.loss;
export const selectLossLimitMessage = state => state[NS]?.lossLimitMessage?.show;
export const selectHasBalanceLimit = state => state[NS].balanceLimitMust;
